import styled from "styled-components";

export const StyledInfoCard = styled.div<{ $status: "success" | "error" }>`
    padding: 6px 16px;
    display: flex;
    gap: 12px;
    border-radius: 4px;
    background-color: ${({ theme, $status }) =>
        `color-mix(in srgb, ${
            $status === "success"
                ? theme.successTypographyColor
                : theme.dangerTypographyColor
        } 20%, transparent)`};

    border: 1px solid
        ${({ theme, $status }) =>
            $status === "success"
                ? theme.successTypographyColor
                : theme.dangerTypographyColor};
`;
